import inviteOnlyErrorBg from '@/assets/user-not-invited.jpg';
import ErrorMessage from '@/components/ErrorMessage';
import PageLayout from '@/components/general/PageLayout';
import useLogout from '@/hooks/useLogout';

const NotInvitedComponent = (): JSX.Element => {
  const logout = useLogout();
  return (
    <PageLayout>
      <ErrorMessage
        data-testid="not-invited-page"
        title="Zion is an invite-only platform"
        illustration={inviteOnlyErrorBg}
        aboveTitle="Our apologies"
        buttonAction={logout}
        buttonLabel="Go back to the login page"
        description={
          <div>
            <p>
              If you have received an invitation to join Zion, please check that you&apos;re using
              the correct email to sign up.
            </p>
            <p>
              Still need help? Contact{' '}
              <a href="mailto:zion-support@trio.dev">zion-support@trio.dev</a>.
            </p>
          </div>
        }
      />
    </PageLayout>
  );
};

export default NotInvitedComponent;
